import classNames from 'classnames';

// Refactored
const PanelTitleWrapper = props => {
  const { children, ...rest } = props;
  return <div className={classNames('c-panel__title-wrapper')}>{children}</div>;
};

export default PanelTitleWrapper;
